import React from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton, useTheme } from '@mui/material'

interface DeleteIconButtonProps {
  hasErrors: boolean
  onDelete: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({ hasErrors, onDelete }) => {
  const theme = useTheme()

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    onDelete(e)
  }

  return (
    <IconButton
      disabled={hasErrors}
      onClick={handleDelete}
      sx={{
        height: 28,
        width: 28,
        backgroundColor: theme.palette.background.default,
        ':hover': {
          backgroundColor: 'text.error',
        },
        '&.Mui-disabled': {
          backgroundColor: 'rgb(52, 60, 73)', // Custom background color when disabled
        },
      }}
    >
      <DeleteIcon
        sx={{
          color: hasErrors ? 'rgba(231, 109, 137, 0.5)' : '',
          height: 22,
          width: 22,
        }}
      />
    </IconButton>
  )
}

export default DeleteIconButton
